// Types Actions
export const SCREEN_CHANGE = 'screen/change';

export interface DialogActionTypes {
  type: typeof SCREEN_CHANGE;
  payload: Boolean;
}
